import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { TrackManager } from "@x-mile/api-contract";
import type { GetVehicleParams } from "../model";

export const useGetVehicle = (
  params: GetVehicleParams,
  options?: QueryOptions<typeof TrackManager.useGetVehicle>,
): UseQueryResult<TrackManager.GetVehicleQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getVehicle", keysToSnakeCase(params)],
    queryFn: () =>
      TrackManager.getVehicle(
        params.id,
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    TrackManager.GetVehicleQueryResult,
    undefined
  >;
};

export const useMultipleGetVehicle = (
  paramsList: { [key: string | number]: GetVehicleParams },
  options?: QueryOptions<typeof TrackManager.useGetVehicle> & {
    sortFunc?: (a: GetVehicleParams, b: GetVehicleParams) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    TrackManager.GetVehicleQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getVehicle", keysToSnakeCase(params)],
        queryFn: () =>
          TrackManager.getVehicle(
            params.id,
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      TrackManager.GetVehicleQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetVehicleMock = (
//   params: GetVehicleParams,
//   options?: QueryOptions<typeof TrackManager.useGetVehicle>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await TrackManager.startMockServerWoker(
//         TrackManager.getGetVehicleMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetVehicle(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetVehicleMock = (
//   paramsList: { [key: string | number]: GetVehicleParams },
//   options?: QueryOptions<typeof TrackManager.useGetVehicle>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await TrackManager.startMockServerWoker(
//         TrackManager.getGetVehicleMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetVehicle(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
